import { APPROVALS_ADD_APPROVER_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

import {
	type ApprovalsWriteExperience,
	useApprovalsWriteExperience,
} from './useApprovalsWriteExperience.ts';

/**
 * Tracks `approvals/add-approver` — an approver was added to an active review.
 */
export const useAddApproverExperience = (): ApprovalsWriteExperience =>
	useApprovalsWriteExperience(APPROVALS_ADD_APPROVER_EXPERIENCE);
